module.exports = __webpack_public_path__ + "img/omission.a5fcbde9.svg";